import styles from 'partials/data-table/data-table.module.scss';

export const DataTableRowList = ({ children }) => {
	return <ul className={styles.rowList}>{children}</ul>;
};
